import React from 'react';
import PaymentsModal from '../PaymentsModal';
import RecurlyPaymentForm from '../RecurlyPaymentForm';
import { ISubscriptionUpdatePaymentModal } from '../../../interfaces';

const SubscriptionUpdatePaymentModal: React.FunctionComponent<ISubscriptionUpdatePaymentModal> = ({
  onSuccess,
  onClose,
  isOpen,
  title,
  subtitle,
  hasError,
}): JSX.Element => (
  <PaymentsModal
    title={title || ''}
    subtitle={subtitle}
    isOpen={isOpen}
    onClose={onClose}
    hasError={hasError}
  >
    <RecurlyPaymentForm onSuccess={onSuccess} />
  </PaymentsModal>
);

export default SubscriptionUpdatePaymentModal;
